import React, { useEffect } from "react";
import Header from "../components/Header";
import QuickActions from "../components/QuickActions";
import AssociatedChains from "../components/AssociatedChains";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchLoggedUserChains } from "state/logged_user_chains";
import { State } from "state";

const styles = {
  container: {
    Height: "100%",
    backgroundColor: "#DFDFDF",
    display: "flex",
    flexDirection: "column" as const,
    width: "100%",
  },
  main: {
    width: "100%",
    height: "100%",
    // minHeight: "100%",
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "start",
    // padding: "1.5rem",
    gap: "2rem",
    backgroundColor: "#DFDFDF",
  },
  sub_main: {
    // height: "100%",
    backgroundColor: " rgba(255, 255, 255, 0.559)",
    display: "flex",
    flexDirection: "column" as const,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
    gap: "2rem",
    borderRadius: "16px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    padding: "1.5rem 1.5rem 3.5rem 1.5rem",
  },
  line_separator: {
    height: "1px",
    width: "100%",
    backgroundColor: "#BAC0CC",
  },
};

type ChainProps = RouteComponentProps;

const AssociatedChainsPage: React.FC<ChainProps> = () => {
  const dispatch = useDispatch();
  const { content: chains } = useSelector((state: State) => state.logged_user_chains);

  useEffect(() => {
    dispatch(fetchLoggedUserChains());
  }, [dispatch]);
  return (
    // <div style={styles.container}>
    <main style={styles.main}>
      <div style={styles.sub_main}>
        <QuickActions chains={chains} />
        <div style={styles.line_separator}></div>
        <AssociatedChains />
      </div>
    </main>
    // </div>
  );
};

export default withRouter(AssociatedChainsPage);
